import 'styled-components';

import colors from './colors';
import fontSize from './fontSize';
import fontWeight from './fontWeight';
import breakpoints from './breakpoints';
import radius from './radius';
import shadows from './shadows';

export const theme1 = {
  colors,
  fontSize,
  fontWeight,
  breakpoints,
  radius,
  shadows
} as const;

declare module 'styled-components' {
  export interface DefaultTheme {
    appTheme?: string;
    colors: typeof colors;
    fontSize: typeof fontSize;
    fontWeight: typeof fontWeight;
    breakpoints: typeof breakpoints;
    radius: typeof radius;
    shadows: typeof shadows;
  }
}
